var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.663,
    height: 95.663,
    viewBox: "0 0 95.663 95.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-71 -116)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(71 116)",
    fill: "#4d93a5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(71 133.272)",
    fill: "#4d93a5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(71 150.545)",
    fill: "#4d93a5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(71 167.817)",
    fill: "#4d93a5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(71 185.09)",
    fill: "#4d93a5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(71 202.362)",
    fill: "#4d93a5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(88.272 116)",
    fill: "#4d93a5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(88.272 133.272)",
    fill: "#4d93a5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(88.272 150.545)",
    fill: "#4d93a5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(88.272 167.817)",
    fill: "#4d93a5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(88.272 185.09)",
    fill: "#4d93a5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(88.272 202.362)",
    fill: "#4d93a5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(105.545 116)",
    fill: "#4d93a5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(105.545 133.272)",
    fill: "#4d93a5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(105.545 150.545)",
    fill: "#4d93a5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(105.545 167.817)",
    fill: "#4d93a5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(105.545 185.09)",
    fill: "#4d93a5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(105.545 202.362)",
    fill: "#4d93a5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(122.817 116)",
    fill: "#4d93a5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(122.817 133.272)",
    fill: "#4d93a5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(122.817 150.545)",
    fill: "#4d93a5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(122.817 167.817)",
    fill: "#4d93a5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(122.817 185.09)",
    fill: "#4d93a5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(122.817 202.362)",
    fill: "#4d93a5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(140.09 116)",
    fill: "#4d93a5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(140.09 133.272)",
    fill: "#4d93a5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(140.09 150.545)",
    fill: "#4d93a5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(140.09 167.817)",
    fill: "#4d93a5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(140.09 185.09)",
    fill: "#4d93a5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(140.09 202.362)",
    fill: "#4d93a5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(157.362 116)",
    fill: "#4d93a5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(157.362 133.272)",
    fill: "#4d93a5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(157.362 150.545)",
    fill: "#4d93a5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(157.362 167.817)",
    fill: "#4d93a5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(157.362 185.09)",
    fill: "#4d93a5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M4.65,0A4.65,4.65,0,1,1,0,4.65,4.65,4.65,0,0,1,4.65,0Z",
    transform: "translate(157.362 202.362)",
    fill: "#4d93a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.a2bd66d1.svg";
export { ForwardRef as ReactComponent };